import { useTranslations } from "@jugl-web/utils";
import React from "react";

export const NotTrainedPill: React.FC = () => {
  const { t } = useTranslations();

  return (
    <div className="bg-tertiary-50 border-tertiary-100 flex h-7 shrink-0 items-center justify-center rounded-xl border border-solid px-2">
      <span className="text-dark-800 font-secondary text-xs font-medium">
        {t({
          id: "cx-ai-agents-page.not-trained",
          defaultMessage: "Not trained",
        })}
      </span>
    </div>
  );
};
